export const BILLING_CYCLE_ORDER_COUNTS_PATH = '/api/billing-cycle-order-counts'

export type BillingCycleRange = {
  start?: string
  end?: string
  end_exclusive?: string
}

export type BillingCycleOrderCountsData = {
  last_billing_cycle_orders_count?: unknown
  last_billing_cycle_90_days_orders_count?: unknown
  is_free_plan?: boolean
  cycle_source?: string
  last_billing_cycle?: BillingCycleRange
  last_billing_cycle_90_days?: BillingCycleRange
}

export type BillingCycleOrderCountsResponse = {
  status_code?: number
  message?: string
  data?: BillingCycleOrderCountsData | null
}

/** Safe non-negative integer for display; never NaN/undefined. */
export function parseBillingCycleOrderCount(value: unknown): number {
  if (value === null || value === undefined || value === '') {
    return 0
  }
  const parsed = typeof value === 'number' ? value : Number(String(value).replace(/,/g, '').trim())
  if (!Number.isFinite(parsed) || parsed < 0) {
    return 0
  }
  return Math.trunc(parsed)
}

export function isBillingCycleOrderCountsSuccess(
  response: BillingCycleOrderCountsResponse | null | undefined
): boolean {
  return response?.status_code === 200 && response?.data != null
}

export function mapBillingCycleOrderCountsFromApiResponse(
  response: BillingCycleOrderCountsResponse | null | undefined
): { ordersLast30: number; ordersLast90: number } {
  const data = response?.data
  return {
    ordersLast30: parseBillingCycleOrderCount(data?.last_billing_cycle_orders_count),
    ordersLast90: parseBillingCycleOrderCount(data?.last_billing_cycle_90_days_orders_count),
  }
}
